import React from 'react';
import { Role } from '../../consts';
import TopLevelNavigationDropdownItem from '../TopLevelNav/TopLevelNavigationDropdownItem';
import TopLevelNavigationItem from '../TopLevelNav/TopLevelNavigationItem';
import AccountMenu from './AccountMenu';
import StaticAccountDropdown from './StaticAccountDropdown';

interface Props {
    role: Role;
    isStaticTemplate?: boolean;
}

export default function AccountNavigation({ role, isStaticTemplate = false }: Props) {
    return (
        <div className="site-header__item site-header__item--account-navigation">
            {role !== 'logged-out' && (
                <div className="top-level-nav">
                    {isStaticTemplate && <StaticAccountDropdown role={role} />}
                    {!isStaticTemplate && (
                        <TopLevelNavigationDropdownItem
                            label={
                                <span className="avatar avatar--extra-small">
                                    <img
                                        alt=""
                                        className="avatar__image"
                                        src="/avatars/current-user/32"
                                    />
                                </span>
                            }
                            url="/account/personal-information"
                            additionalClasses={[
                                'top-level-nav__item--first',
                                'top-level-nav__item--account',
                            ]}
                            showArrow={false}
                            align="right"
                        >
                            <AccountMenu role={role} />
                        </TopLevelNavigationDropdownItem>
                    )}
                </div>
            )}
            {role === 'logged-out' && (
                <div className="top-level-nav">
                    <TopLevelNavigationItem
                        label={__('Log in')}
                        url="/login"
                        additionalClasses={['top-level-nav__item--first']}
                        linkAdditionalClasses={['SMOKETEST_login_link']}
                        linkAttributes={{
                            'data-globalnavui-loginlink': 'data-globalnavui-loginlink',
                        }}
                    />
                </div>
            )}
        </div>
    );
}
